import { strings } from '@/constants/strings';
import { Response } from '@/types/wellbeing-response';

export const getWellbeingResponseText = ({ response }: Response): string => {
  switch (response) {
    case 'NoResponse':
      return strings.wellbeing_responses.no_response;
    case 'PositiveResponse':
      return strings.wellbeing_responses.positive_response;
    case 'NegativeNoHelp':
      return strings.wellbeing_responses.negative_no_help_response;
    case 'NegativeWithHelp':
      return strings.wellbeing_responses.negative_with_help_response;
    default:
      return strings.wellbeing_responses.unhandled_response;
  }
};
